
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Color from 'color';
import IconColors from '@/config/IconColors';

let globalIdCounter = 0;

@Component({
  name: 'CircleIcon'
})
export default class CircleIcon extends Vue {
  @Prop({ default: 40 })
  private size: number;

  @Prop()
  private color: string;

  @Prop()
  private fillId: string;

  @Prop({ default: false })
  private gradient: boolean;

  private gradientIdCounter: number;

  beforeCreate() {
    this.gradientIdCounter = globalIdCounter;
    globalIdCounter++;
  }

  private newUrl(id: string) {
    return `url(#${id})`;
  }

  get fill() {
    if (this.fillId) {
      return this.newUrl(this.fillId);
    }

    if (this.gradient && !this.gradientFromColor) {
      return this.newUrl(this.gradientId);
    } else if (this.gradient) {
      return this.newUrl(this.gradientFromColor);
    }

    return this.color;
  }

  get linearGradientColor() {
    return Color(this.color).darken(0.2).string();
  }

  get gradientId() {
    return `gradient-${this.gradientIdCounter}-${this.color.substr(1)}`;
  }

  get gradientFromColor() {
    return IconColors.codeToName(this.color);
  }
}
